document.addEventListener("DOMContentLoaded", () => {
  let hasShownThisSession = false;

  // 1. Add Google Fonts and Material Symbols to Head
  const fontLink = document.createElement('link');
  fontLink.rel = 'stylesheet';
  fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;800&family=Playfair+Display:wght@700&display=swap';
  document.head.appendChild(fontLink);

  const iconLink = document.createElement('link');
  iconLink.rel = 'stylesheet';
  iconLink.href = 'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200';
  document.head.appendChild(iconLink);

  const style = document.createElement('style');
  style.innerHTML = `
    #upsell-popup {
      position: fixed; top: 0; left: 0; width: 100%; height: 100%;
      background: rgba(10, 31, 61, 0.4); 
      display: flex; align-items: center; justify-content: center;
      z-index: 99999; font-family: 'Inter', sans-serif; padding: 15px; box-sizing: border-box;
    }

    #upsell-popup-container {
      background: #ffffff; border-radius: 12px; position: relative;
      max-width: 850px; width: 100%; max-height: 95vh; overflow-y: auto;
      box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15); color: #0a1f3d;
      padding-bottom: 20px;
    }

    /* Header */
    .upsell-header { text-align: center; padding: 40px 20px 20px; }
    .upsell-title { 
      font-family: 'Playfair Display', serif; font-size: 44px; 
      line-height: 1.1; font-weight: 400 !important; text-transform: uppercase; 
      letter-spacing: 1px; margin: 10px 0; color: #0a1f3d;
    }
    .upsell-subtitle { 
      font-size: 14px; font-weight: 400; text-transform: uppercase;
      color: #0a1f3d; display: flex; align-items: center; justify-content: center; gap: 10px;
    }
    .upsell-subtitle span { color: #d35400; font-size: 18px; }

    /* Grid */
    .upsell-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; padding: 0 30px; }

    .upsell-card {
      border: 1px solid #eee; border-radius: 12px; padding: 25px;
      display: flex; flex-direction: column; align-items: center; text-align: center; position: relative;
    }

    .card-recommended { border: 2px solid #e67e22; background-color: #fffaf5; }
    
    .recommended-tag {
      position: absolute; top: 0; right: 0; background: #d35400;
      color: white; font-size: 10px; font-weight: 800; padding: 6px 14px;
      border-bottom-left-radius: 8px; border-top-right-radius: 10px; text-transform: uppercase;
    }

    .qty-big { font-family: 'Playfair Display', serif; font-size: 70px; line-height: 1; margin-bottom: 5px; }
    .qty-sub { font-size: 12px; font-weight: 800; text-transform: uppercase; letter-spacing: 1px; color: #0a1f3d; }
    
    /* Dividers */
    .upsell-divider { width: 100%; height: 1px; background: #e0e0e0; margin: 18px 0; border: none; }
    
    .feature-green { color: #1e7039; font-weight: 800; font-size: 15px; text-transform: uppercase; }
    .feature-sub { font-size: 13px; color: #555; margin-bottom: 15px; font-weight: 500; }

    /* Flow Box */
    .flow-pill {
      background: #fdf2e9; padding: 12px 15px; border-radius: 6px;
      font-size: 12px; font-weight: 700; width: 90%; color: #0a1f3d;
    }
    .flow-pill span { color: #d35400; margin: 0 4px; font-weight: 900; }

    /* Bullet Points */
    .bullet-list { text-align: left; width: 100%; margin: 20px 0; flex-grow: 1; }
    .bullet-item { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; font-size: 13px; font-weight: 500; }
    .bullet-item .material-symbols-outlined { font-size: 20px; color: #0a1f3d; opacity: 0.8; }
    .text-green { color: #1e7039; font-weight: 700; }

    /* Buttons */
    .btn-cta {
      width: 100%; padding: 15px; border-radius: 6px; font-size: 15px; font-weight: 800;
      cursor: pointer; text-transform: uppercase; display: flex; align-items: center;
      justify-content: center; gap: 8px; transition: 0.2s; border: none;
    }
    .btn-orange { background: #d35400; color: white; }
    .btn-outline { background: white; color: #0a1f3d; border: 1.5px solid #0a1f3d; }

    /* The "Dock" Footer */
    .fit-footer-wrapper { padding: 20px 0; display: flex; justify-content: center; }
.fit-footer-dock {
  background: #fdf6ec;
  padding: 10px 25px;
  border-radius: 10px;
  border: 1px solid #fae5cc;
  font-style: italic;
  font-size: 13px;

  display: flex;
  align-items: center;
  justify-content: center; /* horizontal center */

  gap: 8px;
  width: 92%;
  text-align: center;
}
    .fit-footer-dock .material-symbols-outlined { color: #0a1f3d; font-size: 18px; font-weight: 800; }

    #upsell-close-x {
      position: absolute; top: 15px; right: 20px; border: none; background: none;
      font-size: 30px; cursor: pointer; color: #0a1f3d; opacity: 0.5;
    }
    #upsell-close-x:hover { opacity: 1; }

    @media (max-width: 768px) {
      .upsell-grid { grid-template-columns: 1fr; }
      .upsell-title { font-size: 32px; }
      .fit-footer-dock { max-width: 95%; font-size: 12px; }
    }
  `;
  document.head.appendChild(style);

  function showUpsell(quantity) {
    if (hasShownThisSession || quantity < 2 || quantity > 5) return;

    const overlay = document.createElement("div");
    overlay.id = "upsell-popup";

    overlay.innerHTML = `
      <div id="upsell-popup-container">
        <button id="upsell-close-x">&times;</button>
        
        <div class="upsell-header">
           <div style="color:#d35400;"><span class="material-symbols-outlined" style="font-size:40px;">flight_takeoff</span></div>
           <h1 class="upsell-title">GET THE PERFECT FIT<br>NO GUESSWORK</h1>
           <div class="upsell-subtitle"><span>★</span> Trusted by Pilots Since 1991 <span>★</span></div>
        </div>

        <div class="upsell-grid">
          <!-- Card 1: 6+ -->
          <div class="upsell-card card-recommended">
            <div class="recommended-tag">Recommended</div>
            <div class="qty-big">6+</div>
            <div class="qty-sub">Pilot Shirts</div>
            
            <hr class="upsell-divider">
            
            <div class="feature-green">Get Free Trial Shirt First <br>For Fit Check</div>
            <div class="feature-sub"></div>
            
            <div class="flow-pill">
              Try First <span>&rarr;</span> Approve <span>&rarr;</span> We Produce
            </div>

            <hr class="upsell-divider">

            <div class="bullet-list">
              <div class="bullet-item"><span class="material-symbols-outlined">inventory_2</span> Trial shirt ships first</div>
              <div class="bullet-item"><span class="material-symbols-outlined">verified</span> Final production after approval</div>
              <div class="bullet-item"><span class="material-symbols-outlined">public</span> <span class="text-green">Free</span> worldwide shipping</div>
              </div>

            <button class="btn-cta btn-orange" id="upsell-confirm-5">Get 5+ Shirts <span class="material-symbols-outlined">arrow_forward</span></button>
          </div>

          <!-- Card 2: 3+ -->
          <div class="upsell-card">
            <div class="qty-big">4 - 5</div>
            <div class="qty-sub">Pilot Shirts</div>
            
            <hr class="upsell-divider">
            
            <div style="font-weight: 700; font-size: 14px;">1st Shirt part of the order delivered first</div>
            <div class="feature-sub">Balance sent after confirmation</div>
            
            <hr class="upsell-divider">

            <div class="bullet-list">
              <div class="bullet-item"><span class="material-symbols-outlined">check_circle</span> Fit check before bulk production</div>
              <div class="bullet-item"><span class="material-symbols-outlined">local_shipping</span> <span class="text-green">Free</span> worldwide shipping</div>
            </div>

            <button class="btn-cta btn-outline" id="upsell-decline">Continue <span class="material-symbols-outlined">arrow_forward</span></button>
          </div>
        </div>

        <div class="fit-footer-wrapper">
          <div class="fit-footer-dock">
            <span class="material-symbols-outlined">task_alt</span>
            Trial fit confirms your sizing before final production.
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(overlay);
    hasShownThisSession = true;

    const closePopup = () => overlay.remove();
    document.getElementById("upsell-close-x").onclick = closePopup;
    document.getElementById("upsell-decline").onclick = closePopup;
    document.getElementById("upsell-confirm-5").onclick = closePopup;
    overlay.onclick = (e) => { if (e.target === overlay) closePopup(); };
  }

  // Trigger setup
  setTimeout(() => {
    const inputs = document.querySelectorAll("input.ymq-option-qb-input");
    inputs.forEach(input => {
      input.addEventListener("click", () => {
        const qty = parseInt(input.value);

        if (qty >= 2 && qty <= 5) {
          showUpsell(qty);
        }
      });
    });
  }, 2000);
});